// ─────────────────────────────────────────────────────────────────────────────
// CardHeader — the "Global Network Map" bar: title on the left, the Map/List
// segmented toggle and the refresh button on the right. The toggle is the only
// thing that decides which view NetworkCard renders.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./NetworkCard.module.css";
import { Icons } from "../../../components/Icons";

const VIEWS = [
  { id: "map",  label: "Map View",  icon: Icons.mapView  },
  { id: "list", label: "List View", icon: Icons.listView },
];

export default function CardHeader({ view, onView, onRefresh }) {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <span className={styles.titleIcon}>{Icons.globe}</span>
        <div>
          <div className={styles.titleName}>Global Network Map</div>
          <div className={styles.titleSub}>Real-time node distribution and status</div>
        </div>
      </div>

      <div className={styles.headerActions}>
        <div className={styles.toggle}>
          {VIEWS.map(({ id, label, icon }) => (
            <button
              key={id}
              className={`${styles.toggleBtn} ${view === id ? styles.toggleBtnActive : ""}`}
              onClick={() => onView(id)}
            >
              {icon} {label}
            </button>
          ))}
        </div>
        <button className={styles.refresh} onClick={onRefresh} title="Refresh">↺</button>
      </div>
    </div>
  );
}
